import useTranslation from 'next-translate/useTranslation';

const InCart = () => {
  const { t } = useTranslation();

  return (
    <div className="w-fit py-4 text-left">
      <p>{t('product:already-in-cart')}</p>
    </div>
  );
};

export default InCart;
